

















































import { Component, Vue } from "vue-property-decorator";

import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import FAQ from "@/components/FAQ.vue";
import Form from "@/components/Form.vue";

import { Start, Patient } from "@/components/Questions/questions";

import { createMachine, interpret, StateMachine, EventObject } from "@xstate/fsm";
import State from "@/state";

@Component({
  components: { Navbar, Footer, Form, FAQ, Start, Patient },
})
export default class App extends Vue {
  private stateMachine!: StateMachine.Machine<
    object,
    EventObject,
    {
      value: string;
      context: object;
    }
  >;
  private stateMachineService!: StateMachine.Service<
    object,
    EventObject,
    {
      value: string;
      context: object;
    }
  >;

  private state: string = State.Start;
  private lastEvent: string | null = State.Visitor;

  created() {
    // Language
    const language = window.navigator.language.split("-")[0];
    if (language) {
      this.$i18n.locale = language;
    } else {
      this.$i18n.locale = "de";
    }

    const html = document.documentElement; // returns the html tag
    html.setAttribute("lang", this.$i18n.locale);
    window.document.title = this.$t("title").toString();
    // END Language

    // State Machine
    this.stateMachine = createMachine(
      {
        id: "toggle",
        initial: State.Form,
        states: {
          START: {
            on: { PATIENT: State.Patient, VISITOR: State.Form, COMPANION: State.Form },
            exit: ["exit"],
          },
          PATIENT: {
            on: { PATIENT_CPID: State.Form, PATIENT_CPID_MISSING: State.Form, BACK: State.Start },
            exit: ["exit"],
          },
          FORM: {
            on: { BACK: State.Start },
          },
        },
      },
      {
        actions: {
          // action implementations
          exit: (context, event) => {
            this.lastEvent = event.type;
          },
        },
      }
    );

    this.stateMachineService = interpret(this.stateMachine).start();
    this.stateMachineService.subscribe(state => {
      this.state = state.value[0].toUpperCase() + state.value.substr(1).toLowerCase();
    });
    // END State Machine
  }

  get showStateMachineHeader(): boolean {
    return this.state.toLowerCase() != State.Form.toLowerCase();
  }

  get backState(): string {
    return State.Back;
  }
}
